import React from 'react';
import { Body, Box, Icon } from '@hover/blueprint';
import { iMeh } from '@hover/icons';

interface INoResultsForSearchProps {
  searchKeyword: string;
  resetSearch: () => void;
}

const NoResultsForSearch: React.FC<INoResultsForSearchProps> = ({
  searchKeyword,
  resetSearch,
}) => (
  <Box
    w="100%"
    display="flex"
    alignItems="center"
    flexDir="column"
    mt={{ base: 800, desktop: 0 }}
    minH="84vh"
  >
    <Icon
      icon={iMeh}
      color="warning.500"
      height={500}
      width={500}
      size="default"
      strokeWidth="1px!important"
    />
    <Body
      size={500}
      fontWeight={300}
      d="inline"
      mt={600}
      flexDir="row"
      textAlign="center"
    >
      Sorry, we could not find any search results for &nbsp;
      <Body d="inline" fontWeight={600}>
        “{searchKeyword}”.
      </Body>
    </Body>
    <Body size={500} fontWeight={300} display="inline" textAlign="center">
      Please try again or return to the &nbsp;
      <Box
        d="inline"
        as="button"
        fontWeight={600}
        _hover={{
          textDecoration: 'underline',
          color: 'primary.800',
        }}
        onClick={() => {
          resetSearch();
        }}
        color="primary.600"
      >
        blog overview.
      </Box>
    </Body>
  </Box>
);

export default NoResultsForSearch;
